/* 自营老户升级 */

/** 升级状态 */
export enum UpgradeStateEnum {
  /** 初始状态，未开始升级 */
  INIT = 'INIT',
  /** 已提交升级中 */
  SUBMIT = 'SUBMITTING',
  /** 升级成功 */
  SUCCEEDED = 'SUCCEEDED',
  /** 升级失败 */
  FAILED = 'FAILED',
}


/** 授信任务状态(0初始化、1执行中、2结束、3超时、4压单、5挂起)  */

export enum creditTaskStatusTypeEnum {
  /** 0初始化 */
  INIT = 0,
  /** 1执行中 */
  EXECUTING = 1,
  /** 2结束 */
  END = 2,
  /** 3超时 */
  OUT_TIME = 3,
  /** 4压单 */
  PRESSUER_ORDER = 4,
  /** 5挂起 */
  HANG = 5,
}

/** 授信任务挂起(creditTaskStatusTypeEnum.HANG)场景 */
export enum creditTaskSuspendSceneEnum {
  /** 自营因ocr未补充，授信任务挂起 */
  AUTARKY_OCR_SUSPEND = 'autarkyOcrSuspend',
  /** 轻资产因ocr未补充，授信任务挂起 */
  NO_AUTARKY_OCR_SUSPEND = 'noAutarkyOcrSuspend',
  /** 用户基础信息或紧急联系人未补充，授信任务挂起 */
  USER_BASE_EMERGENCY_SUSPEND = 'userBaseEmergencySuspend',
}

/** 默认返回 experimentB */
export enum galileoTypeEnum {
  /** 实验组1，老客升级首页去除立即升级按钮 */
  EXPERIMENT_A = 'experimentA',
  /** 实验组2，样式和默认组一样 */
  EXPERIMENT_B = 'experimentB',
  /** 默认组， 老客升级样式 */
  DEFAULT = 'default',
  /** 老客升级-无授信成功记录：实验组，无标签新样式页面 */
  CREDIT_EXPERIMENT = 'creditExperiment',
  /** 老客升级-无授信成功记录：对照组，无标签页面 */
  CREDIT_COMPARE = 'creditCompare'
}
